module.exports = __webpack_public_path__ + "img/osmosis-dark.7c423fef.svg";